module.exports = "/fonts/hashed/NotoSansKR-Bold.f499da9b.ttf.gz.bin";